export enum MessageOwnership {
    Owner = 'owner',
    Partner = 'partner',
}

export enum MessageChangeReasons {
    Links = 'links',
    ProhibitedWords = 'prohibitedWords',
}

export enum MessageParticipantStatus {
    New = 'new',
    Read = 'read',
    Hidden = 'hidden',
}

export enum MessageSource {
    Room = 'Room',
    PM = 'PM'
}

